import React, { Component } from "react";

import ImageEditing from "../../../utils/ImageEditing";

import {
  myFileUploadtoServer,
  myDeleteFileOnServer,
  pushDatatoServer,
} from "../../../../components/utils/RequestsHelper";

import classnames from "classnames";

import ReactQuill from "react-quill";

import Checkbox from "@material-ui/core/Checkbox";

import axios from "axios";

import { Link } from "react-router-dom";

import PropTypes from "prop-types";

const styleLabel = {
  width: "100%",
};

class FormAviso extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      title: "",
      description: "",
      smallDescription: '',
      file: "",
      type: "Comunicação",
      isActive: true,
      fileToDelete: "",
    };

    this.setFile = this.setFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFieldsChanges = this.handleFieldsChanges.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps);

    if (nextProps.mode === "Editar" && nextProps.data.title !== undefined) {
      let data = nextProps.data;

      this.setState({
        title: data.title,
        description: data.description,
        smallDescription: data.smallDescription,
        file: data.file,
        type: data.type,
        isActive: data.isActive,
        _id: data._id,
      });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleFieldsChanges = (value, field) => {
    this.setState({ [field]: value });
  };

  handleCheckBoxChange() {
    this.setState({ isActive: !this.state.isActive });
  }

  renderMandatoryMessage = (field) => {
    if (this.state[field] === true) {
      return <span className="alert-danger ml-6">Campo obrigatório</span>;
    }
  };

  setFile = (file, operation) => {
    if (operation === "add") {
      this.setState({ fileToAdd: file });
    }

    if (operation === "delete") {
      if (file.name === this.state.file) {
        this.setState({ fileToDelete: file.name });
      }
      this.setState({ file: "" });
      this.setState({ fileToAdd: null });
    }
  };

  render() {
    const modules = {
      toolbar: [
        ["bold", "italic", "underline", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        ["link", "image"],
      ],
    };

    const formats = [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "align",
      "link",
      "image",
    ];

    return (
      <div className="row">
        <div className="col-12">
          <p className="labels">
            Título*{this.renderMandatoryMessage("titleMissing")}
          </p>
          <input
            className={classnames(
              "input-form",
              this.state.isTitleValid === false ? "bad-form" : ""
            )}
            type="text"
            name="title"
            value={this.state.title}
            placeholder="Título do Aviso"
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12">
          <p className="labels">
            Descrição Pequena (Aparece nas listagens, máximo 250 caracteres.)*{this.renderMandatoryMessage("smallDescriptionMissing")}
          </p>
          <textarea
            className={classnames(
              "input-form",
              this.state.isSmallDescriptionValid === false ? "bad-form" : ""
            )}
            style={{marginBottom: '6px'}}
            type="text"
            rows={5}
            name="smallDescription"
            value={this.state.smallDescription}
            placeholder="Descrição Pequena"
            onChange={this.handleChange}
          />
          <p className="labels" style={{marginBottom: '24px'}}>{this.state.smallDescription.length}/250</p>
        </div>

        <div className="col-12">
          <div
            className={classnames(
              this.state.isDescriptionValid === false ? "bad-form-quill" : ""
            )}
          >
            <p className="labels">
              Descrição*{this.renderMandatoryMessage("descriptionMissing")}
            </p>
            <ReactQuill
              name="description"
              value={this.state.description}
              onChange={(value) =>
                this.handleFieldsChanges(value, "description")
              }
              modules={modules}
              formats={formats}
              placeholder="Descrição do Aviso"
            ></ReactQuill>
          </div>
        </div>

        <div className="col-6 col-sm-3">
          <label style={styleLabel} className="labels">
            Tipo do Aviso*{this.renderMandatoryMessage("typeMissing")}
            <select
              name="type"
              value={this.state.type}
              onChange={this.handleChange}
              className={classnames(
                "input-form",
                this.state.isTypeValid === false ? "bad-form" : ""
              )}
            >
              <option value="Comunicação">Comunicação</option>
              <option value="Aviso">Aviso</option>
            </select>
          </label>
        </div>

        <div className="col-6 col-sm-3">
          {this.state.type === "Aviso" && (
            <div>
              <p className="labels">O Aviso está Ativo?</p>
              <Checkbox
                checked={this.state.isActive}
                onChange={this.handleCheckBoxChange}
                value={this.state.isActive}
                name="isActive"
                inputProps={{
                  "aria-label": "primary checkbox",
                }}
              />
            </div>
          )}
        </div>

        <div className="col-12 col-sm-6">
          <p className="labels">Ficheiro</p>
          {(this.state.title !== "" || this.props.mode === "create") && (
            <ImageEditing
              field={"file"}
              file={this.state.file}
              setFile={(file, operation) => this.setFile(file, operation)}
            />
          )}
        </div>

        <div className="col-12 submit-buttons">
          <button
            onClick={this.handleSubmit}
            className="backoffice-btn btn btn-outline-success"
          >
            {this.props.mode === "create" ? "Adicionar Aviso" : "Editar Aviso"}
          </button>

          <Link
            className="backoffice-btn btn btn-outline-danger"
            to={"/backoffice/avisos"}
          >
            Cancelar
          </Link>
        </div>
      </div>
    );
  }

  handleSubmit() {
    let promises = [];

    //data validation
    let isFormValid = this.validateData();

    if (isFormValid) {

      if (this.state.fileToAdd !== null && this.state.fileToAdd !== undefined) {
        const requestOne = myFileUploadtoServer(
          "/api/file",
          this.state.fileToAdd,
          "post"
        );

        promises.push(
          requestOne
            .then((response) => {
              this.setState({ file: response.data.file });
            })
            .catch((err) => {
              this.setState({ isFileValid: false });
            })
        );
      }

      if (this.state.fileToDelete !== "") {
        let deleteData = {
          path: this.state.fileToDelete,
        };

        promises.push(myDeleteFileOnServer(deleteData));
      }

      axios
        .all(promises)
        .then(
          axios.spread((...responses) => {
            let data = {
              title: this.state.title,
              description: this.state.description,
              smallDescription: this.state.smallDescription,
              type: this.state.type,
              isActive: this.state.isActive,
              file: this.state.file,
            };

            this.saveAviso(data);
          })
        )
        .catch((errors) => {});
    }
  }

  saveAviso = async (data) => {
    let res = {};
    try {
      if (this.props.mode === "create") {
        res = await pushDatatoServer("/api/avisos", data, "post");
      } else {
        res = await pushDatatoServer(
          "/api/avisos/" + this.state._id,
          data,
          "put"
        );
      }

      if (
        res.response !== undefined &&
        res.response.data !== undefined &&
        res.response.data.errors !== undefined &&
        res.response.data.errors.length !== 0
      ) {
        console.log("tem erros");
        console.log(res.response.data.errors);
      } else {
        console.log("não tem erros");
        this.context.router.history.push("/backoffice/avisos");
      }
    } catch (err) {
      this.context.router.history.push("/backoffice/avisos");
    }
  };

  validateData = () => {
    let isFormValid = true;

    if (!this.validateField("title", "isTitleValid")) {
      isFormValid = false;
    }

    if (!this.validateField("description", "isDescriptionValid")) {
      isFormValid = false;
    }

    if (!this.validateField("smallDescription", "isSmallDescriptionValid")) {
      isFormValid = false;
    }

    if (!this.validateField("type", "isTypeValid")) {
      isFormValid = false;
    }

    return isFormValid;
  };

  validateField = (field, isValidValue) => {
    let newState = {};
    let isValid = true;
    let missingString = field + "Missing";

    if (
      this.state[field] === "" ||
      this.state[field] === undefined ||
      this.state[field].length === 0
    ) {
      this.setState({ [missingString]: true });
      isValid = false;
    } else {
      this.setState({ [missingString]: "" });
    }

    newState[isValidValue] = isValid;
    this.setState(newState);
    return isValid;
  };
}

export default FormAviso;
